module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('picture', {
    staticClass: "intrinsic",
    class: _vm.ratioClass,
    style: (_vm.ratioStyle)
  }, [(_vm.medium) ? _c('source', {
    attrs: {
      "media": "(min-width: 40em)",
      "srcset": _vm.medium
    }
  }) : _vm._e(), _vm._v(" "), (_vm.large) ? _c('source', {
    attrs: {
      "media": "(min-width: 40em)",
      "srcset": _vm.large
    }
  }) : _vm._e(), _vm._v(" "), (_vm.lazyLoad) ? _c('img', {
    staticClass: "intrinsic-item swiper-lazy",
    class: _vm.fitMe,
    attrs: {
      "data-src": _vm.small,
      "alt": _vm.alt
    }
  }) : _c('img', {
    staticClass: "intrinsic-item",
    class: _vm.fitMe,
    attrs: {
      "src": _vm.small,
      "alt": _vm.alt
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-80220024"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/shared/intrinsic.vue
// module id = 185
// module chunks = 4